import { useEffect, useState } from 'react';

const FALLBACK_TIMEOUT = 3000;

/**
 * Returns `hasFallback: true` once a short timeout elapses, so create-and-redirect
 * pages can surface an escape hatch if the redirect hasn't happened yet.
 */
export const useFallbackMode = () => {
  const [hasFallback, setHasFallback] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setHasFallback(true);
    }, FALLBACK_TIMEOUT);

    return () => clearTimeout(timeout);
  }, []);

  return { hasFallback };
};
